export enum Disbursement {
  direct_deposit = "Direct Deposit",
  direct_deposit_same_day = "Direct Deposit Same Day",
  physical_check = "Physical Check",
  download_check = "Download Check",
  paycard = "Paycard",
  prepaid = "Pre-Paid",
}

export enum DisbursementStatus {
  returned = "Returned",
  canceled = "Canceled",
  pending = "Pending",
  settled = "Settled",
  net_pay_void = "Net Pay Void",
  refunded = "Refunded",
}
